import React, { useEffect } from 'react';
import { useSelectMultipleFile } from '@/hooks/useSelectMultipleFile';
import { Spinner } from 'reactstrap';
import { nanoid } from 'nanoid';
import doc from '@/assets/doc.png';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

type DocUploaderProps = {
  src: string;
  setImage: (img: string) => void;
  labbel?: string;
  error: boolean;
  placeholder?: string;
  type?: string;
  setSize?: (size: any) => void;
  setName?: any;
};

const style: React.CSSProperties | undefined = {
  right: '15px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  color: '#aaa',
  fontSize: '18px',
  cursor: 'pointer',
  position: 'absolute',
};

export const DocUploader = ({ src, setImage, labbel, error, placeholder }: DocUploaderProps) => {
  const id: string = nanoid();

  const {
    images,
    handleChange,
    uploaded,
    deleteImage,
    text,
    setText,
    load,
    size,
    pdfNames,
    pdfName,
  } = useSelectMultipleFile();

  useEffect(() => {
    if (uploaded && uploaded[0]) {
      setImage(uploaded[0]);
    }
  }, [images]);

  const handleDelete = () => {
    deleteImage(0);
    setImage('');
  };

  return (
    <>
      <span className="upload-file-label d-block mb-1 f-14">{labbel}</span>
      {load ? (
        <div className="position-relative margin-none mt-0 mb-3">
          <Spinner />
        </div>
      ) : src && src !== '' ? (
        <div className="row crosses-select addd doc-uploader">
          <div className="cross-pic">
            <div
              className="w-100 image-box"
              style={{
                minHeight: '48px',
                border: '1px solid #26323899',
                borderRadius: '10px',
              }}
            >
              <button type="button" onClick={handleDelete}>
                {/* <i className="fa-solid fa-square-xmark pics"></i> */}
                <CloseRoundedIcon className='close-icon'/>
              </button>
              {pdfNames.length > 0 ? pdfNames : src?.split('/').pop()}
            </div>
          </div>
        </div>
      ) : (
        <div className="position-relative margin-none mt-0">
          <div className="d-block single">
            <input
              type="file"
              name="uploadFiles"
              id={id}
              onChange={handleChange}
              accept=".pdf, .doc, .docx, .txt, .rtf, .xls, .xlsx"
              className="d-none"
              placeholder={placeholder}
            />
            <label htmlFor={id} style={{ display: 'inline' }}>
              <span className="uploadFile">
                <div className="relative">
                  <div
                    style={{
                      minHeight: '48px',
                      border: '1px solid #26323899',
                      borderRadius: '10px',
                    }}
                  ></div>
                  <img src={doc} alt="" className="upload-img-src" style={style} />
                  <span
                    className=""
                    style={{
                      position: 'absolute',
                      top: '14px',
                      left: '14px',
                      color: '#263238',
                      fontSize: '14px',
                    }}
                  >
                    {placeholder}
                  </span>
                </div>
              </span>
            </label>
          </div>

          {error && <span className="pt-4 tetx-sm text-red-500">Please upload the doc</span>}
        </div>
      )}
    </>
  );
};
